(function (angular) {
    'use strict';

    /*
     Creates a new sub-module to be used for error pages
     */
    var app = angular.module('enervee.supportPage', []);

    /*
     Creates a new controller for the error pages called "SupportPageCtrl"
     */
    app.controller('SupportPageCtrl', [
        'UtilService',
        function (
            UtilService
        ) {
            var vm = this;
            //has to match Reamaze admin configuration
            vm.reamazeFaqSettings = UtilService.getSiteSetting('reamaze_faq_config', {});
            vm.reamazeConf = {
                widgetAccount: vm.reamazeFaqSettings.account,
                widgetBrandId: vm.reamazeFaqSettings.brand
            };
        }
    ]);

})(angular);
